module.exports = __webpack_public_path__ + "img/w3_package_thin_light.bec29d1d.png";